import React from "react";
import PropTypes from "prop-types";

import { Spinner } from "reactstrap";

import "./overlay.scss";

const Overlay = ({ isOpen }) => (
    <div className={`overlay ${isOpen && 'open'}`}>
        <Spinner size="lg" color="primary" />
    </div>
);

Overlay.propTypes = {
    isOpen: PropTypes.bool.isRequired
};

export { Overlay }
